var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 14,
    viewBox: "0 0 38 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2049_15104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4639 1.4442C26.866 1.20702 25.9178 0.945129 24.7452 0.945129C21.752 0.945129 19.6441 2.54131 19.6312 4.82336C19.6063 6.50706 21.1403 7.44222 22.2877 8.00362C23.4603 8.57728 23.859 8.95171 23.859 9.46306C23.847 10.2484 22.9114 10.6104 22.0387 10.6104C20.8286 10.6104 20.1801 10.4237 19.1947 9.98683L18.7956 9.79953L18.3715 12.431C19.0824 12.7549 20.3921 13.0423 21.752 13.0549C24.9324 13.0549 27.0029 11.4834 27.0275 9.0515C27.0396 7.71704 26.2295 6.69452 24.4832 5.85897C23.423 5.3226 22.7738 4.96094 22.7738 4.41214C22.7862 3.91323 23.3229 3.40222 24.5197 3.40222C25.505 3.37719 26.229 3.61405 26.7775 3.85107L27.0517 3.97555L27.4639 1.4442Z",
    fill: "url(#paint0_linear_2049_15104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4759 12.8802H13.4449L15.3407 1.15762H18.3716L16.4759 12.8802Z",
    fill: "url(#paint1_linear_2049_15104)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2339 1.15762H32.8894C32.1664 1.15762 31.6171 1.36945 31.3051 2.13025L26.8029 12.88H29.9833C29.9833 12.88 30.5069 11.4332 30.6194 11.1216H34.5111C34.5981 11.5331 34.8727 12.88 34.8727 12.88H37.6792L35.2339 1.15762ZM31.4924 8.72728C31.7421 8.05384 32.7026 5.44741 32.7026 5.44741C32.6975 5.45745 32.7366 5.34916 32.7948 5.18768L32.7955 5.18571L32.796 5.18441C32.883 4.94321 33.0122 4.58521 33.1014 4.32511L33.3132 5.3352C33.3132 5.3352 33.8872 8.14119 34.0118 8.72728H31.4924Z",
    fill: "url(#paint2_linear_2049_15104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9132 1.15762L7.94476 9.15128L7.62038 7.53007L7.62008 7.52906L6.56024 2.14301C6.38571 1.39431 5.84934 1.18232 5.18832 1.15762H0.311609L0.261719 1.39448C1.45113 1.69863 2.51495 2.13692 3.44708 2.68188L6.14868 12.8677H9.35397L14.1183 1.15762H10.9132Z",
    fill: "url(#paint3_linear_2049_15104)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2049_15104",
    x1: 0.261719,
    y1: 7.02548,
    x2: 37.6792,
    y2: 7.02548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2049_15104",
    x1: 0.261719,
    y1: 7.02548,
    x2: 37.6792,
    y2: 7.02548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2049_15104",
    x1: 0.261719,
    y1: 7.02548,
    x2: 37.6792,
    y2: 7.02548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2049_15104",
    x1: 0.261719,
    y1: 7.02548,
    x2: 37.6792,
    y2: 7.02548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2049_15104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.4175,
    height: 12.1097,
    fill: "white",
    transform: "translate(0.260742 0.945129)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaColor);
export default __webpack_public_path__ + "static/media/visa-color.d3453db24e4ca87778d01cc9a67e2f7c.svg";
export { ForwardRef as ReactComponent };